import { render, staticRenderFns } from "./ShopFloor.vue?vue&type=template&id=c45dc886&scoped=true&"
import script from "./ShopFloor.vue?vue&type=script&lang=js&"
export * from "./ShopFloor.vue?vue&type=script&lang=js&"
import style0 from "./ShopFloor.vue?vue&type=style&index=0&id=c45dc886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45dc886",
  null
  
)

export default component.exports